import { createSlice } from '@reduxjs/toolkit';

export const transition = createSlice({
  name: 'TRANSITION',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    updateEnterPhase(state, action) {
      return {
        ...state,
        enterPhase: action.payload?.enterPhase,
      };
    },
    updateExitPhase(state, action) {
      return {
        ...state,
        exitPhase: action.payload?.exitPhase,
      };
    },
    updateHasSubmissionPageExitAnimationCompleted(state, action) {
      return {
        ...state,
        hasSubmissionPageExitAnimationCompleted:
          action.payload?.hasSubmissionPageExitAnimationCompleted,
      };
    },
    // Currently this feature is not used. It was added to deal with a custom animation for hard coded newsletter pages. It may be worth removing this and the associated logic.
    updateIsTransitionAnimationEnabledForSubmission(state, action) {
      return {
        ...state,
        isTransitionAnimationEnabledForSubmission:
          action.payload?.isTransitionAnimationEnabledForSubmission,
      };
    },
  },
});

const { actions, reducer } = transition;

export const {
  updateEnterPhase,
  updateExitPhase,
  updateHasSubmissionPageExitAnimationCompleted,
  updateIsTransitionAnimationEnabledForSubmission,
} = actions;

export default reducer;
